import { useEffect, useState } from 'react';
import { interactiveServiceFetch } from '../../services/interactiveServiceFetch';
import { INTERACTIVE_SERVICE_BASE_URL } from '../constants';

const useSessionDebugInfo = (sessionId, refreshKey) => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        setData(null);
    }, [sessionId]);

    useEffect(() => {
        if (!sessionId) return undefined;
        setError(null);

        const controller = new AbortController();
        (async () => {
            try {
                const res = await interactiveServiceFetch(
                    `${INTERACTIVE_SERVICE_BASE_URL}/tracing/sessions/${sessionId}`,
                    { signal: controller.signal }
                );
                if (!res.ok) {
                    setError(`Failed to load debug info (${res.status})`);
                    return;
                }
                setData(await res.json());
            } catch (err) {
                if (err.name !== 'AbortError') {
                    setError(`Failed to load debug info: ${err.message}`);
                }
            }
        })();

        return () => controller.abort();
    }, [sessionId, refreshKey]);

    return { data, error };
};

export default useSessionDebugInfo;
